// Bundle Builder — THG
// Swatch selection, availability checking, gallery updates, pack size handling.
// Safe-by-default: does nothing unless [data-bundle-color-pickers] exists.
(() => {
  const INIT_ATTR = 'data-bundle-initialized';
  const ONE_SIZE = '__onesize__';

  // One-size bundles (e.g. wristbands) have no Size option at all.
  function hasSizeOption() {
    return !!document.querySelector('input[name$="-Size"]');
  }

  // Resolve a stock-map size entry, falling back to the only size for one-size bundles.
  function getSizeData(prod, size) {
    if (!prod || !prod.sizes) return null;
    if (size === ONE_SIZE) {
      var k = Object.keys(prod.sizes);
      return k.length ? prod.sizes[k[0]] : null;
    }
    return prod.sizes[size] || null;
  }

  function getStockMap() {
    const el = document.querySelector('[data-bundle-stock-map]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch(e) { return {}; }
  }

  function getSelectedSize() {
    var el = document.querySelector('input[name$="-Size"]:checked');
    if (el) return el.value.trim();
    if (!hasSizeOption()) return ONE_SIZE;
    return '';
  }

  function getPackSizeFromForm() {
    const packRadio = document.querySelector('input[name$="-Pack Size"]:checked')
      || document.querySelector('input[name$="Pack+Size"]:checked');
    if (packRadio && packRadio.value) {
      const raw = packRadio.value.split(' ')[0].split('-')[0];
      return parseInt(raw, 10) || 0;
    }
    const opt1 = document.querySelector('input[name="option1"]:checked')
      || document.querySelector('select[name="option1"]');
    if (!opt1 || !opt1.value) return 0;
    const raw = opt1.value.split(' ')[0].split('-')[0];
    return parseInt(raw, 10) || 0;
  }

  function ordinal(n) {
    var words = ['first','second','third','fourth','fifth','sixth','seventh','eighth','ninth','tenth','eleventh','twelfth'];
    return words[n - 1] || (n + 'th');
  }

  function getTiers() {
    var el = document.querySelector('[data-bundle-tiers]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch(e) { return {}; }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function clearSlot(slotEl) {
    const hidden = slotEl.querySelector('[data-bundle-slot-value]');
    const label = slotEl.querySelector('[data-bundle-selected-label]');
    slotEl.querySelectorAll('[data-bundle-color-swatch][aria-pressed="true"]').forEach(b => {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });
    if (hidden) hidden.value = '';
    if (label) label.textContent = '';
  }

  function selectSwatch(slotEl, btn) {
    if (!slotEl || !btn || btn.disabled) return;
    const hidden = slotEl.querySelector('[data-bundle-slot-value]');
    const label = slotEl.querySelector('[data-bundle-selected-label]');

    slotEl.querySelectorAll('[data-bundle-color-swatch][aria-pressed="true"]').forEach(b => {
      b.classList.remove('is-selected');
      b.setAttribute('aria-pressed', 'false');
    });

    btn.classList.add('is-selected');
    btn.setAttribute('aria-pressed', 'true');

    if (hidden) hidden.value = btn.getAttribute('data-handle') || '';
    if (label) label.textContent = btn.getAttribute('data-label') || '';
  }

  function updateAvailability(wrapper, stockMap) {
    const size = getSelectedSize();
    if (!size) return;

    const allBtns = wrapper.querySelectorAll('[data-bundle-color-swatch]');
    allBtns.forEach(btn => {
      const handle = btn.getAttribute('data-handle');
      const prod = stockMap[handle];
      if (!prod || !prod.sizes) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        return;
      }
      const sizeData = getSizeData(prod, size);
      const disabled = !sizeData || !sizeData.available;
      btn.disabled = disabled;
      btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    });

    wrapper.querySelectorAll('[data-bundle-slot]').forEach(slotEl => {
      const sel = slotEl.querySelector('[data-bundle-color-swatch][aria-pressed="true"]');
      if (sel && sel.disabled) clearSlot(slotEl);
    });
  }

  function updateGallery(wrapper, stockMap) {
    const gallery = document.querySelector('[data-bundle-gallery]');
    if (!gallery) return;

    var slotEls = Array.from(gallery.querySelectorAll('[data-bundle-gallery-slot]'));
    var requiredSlots = parseInt(wrapper.dataset.requiredSlots || '3', 10);

    var activePickerSlots = wrapper.querySelectorAll('[data-bundle-slot]:not([hidden])');
    var selections = [];
    activePickerSlots.forEach(function(slotEl) {
      var sel = slotEl.querySelector('[data-bundle-color-swatch][aria-pressed="true"]');
      if (sel) {
        var handle = sel.getAttribute('data-handle');
        var prod = stockMap[handle];
        selections.push({
          image: prod && prod.image ? prod.image : '',
          title: prod && prod.title ? prod.title : ''
        });
      }
    });

    // No selections → restore shell product images (show all that have originals)
    if (selections.length === 0) {
      slotEls.forEach(function(slotEl) {
        var img = slotEl.querySelector('[data-bundle-gallery-img]');
        var placeholder = slotEl.querySelector('[data-bundle-gallery-placeholder]');
        var originalSrc = img ? img.getAttribute('data-original-src') : null;

        if (originalSrc) {
          slotEl.hidden = false;
          img.src = originalSrc;
          img.style.display = '';
          img.classList.add('is-loaded');
          if (placeholder) placeholder.style.display = 'none';
        } else {
          slotEl.hidden = true;
        }
      });
      return;
    }

    // Has selections → show selected images + one placeholder for next slot
    var displayCount = selections.length < requiredSlots
      ? selections.length + 1
      : selections.length;

    slotEls.forEach(function(slotEl, i) {
      var img = slotEl.querySelector('[data-bundle-gallery-img]');
      var placeholder = slotEl.querySelector('[data-bundle-gallery-placeholder]');

      if (i >= displayCount) {
        slotEl.hidden = true;
        return;
      }

      slotEl.hidden = false;

      if (i < selections.length) {
        var sel = selections[i];
        if (img && sel.image) {
          img.classList.remove('is-loaded');
          var preload = new Image();
          preload.onload = function() {
            img.src = sel.image;
            img.alt = sel.title;
            img.style.display = '';
            img.classList.add('is-loaded');
          };
          preload.src = sel.image;
        }
        if (placeholder) placeholder.style.display = 'none';
      } else {
        if (img) { img.style.display = 'none'; img.classList.remove('is-loaded'); }
        if (placeholder) {
          placeholder.style.display = '';
          var textEl = placeholder.querySelector('[data-placeholder-text]');
          if (textEl) {
            textEl.textContent = 'Pick your ' + ordinal(i + 1) + ' color';
          }
        }
      }
    });
  }

  function updatePackSize(wrapper) {
    const newPack = getPackSizeFromForm();
    if (!newPack) return;

    const current = parseInt(wrapper.dataset.requiredSlots || '0', 10);
    if (newPack === current) return;

    wrapper.dataset.slots = newPack;
    wrapper.dataset.requiredSlots = newPack;

    const maxSlots = parseInt(wrapper.dataset.maxSlots || '12', 10);
    for (let i = 1; i <= maxSlots; i++) {
      const slot = wrapper.querySelector('[data-bundle-slot="' + i + '"]');
      if (!slot) continue;
      if (i <= newPack) {
        slot.hidden = false;
      } else {
        slot.hidden = true;
        clearSlot(slot);
      }
    }
  }

  function updateATCButton(wrapper, stockMap) {
    const btn = document.querySelector('[data-bundle-atc]');
    if (!btn) return;
    const textEl = btn.querySelector('[data-bundle-atc-text]');

    const required = parseInt(wrapper.dataset.requiredSlots || '0', 10);
    let filled = 0;
    const size = getSelectedSize();
    for (let i = 1; i <= required; i++) {
      const slot = wrapper.querySelector('[data-bundle-slot="' + i + '"]');
      if (slot && slot.querySelector('[data-bundle-color-swatch][aria-pressed="true"]')) filled++;
    }

    const ready = filled === required && !!size;
    btn.disabled = !ready;
    btn.setAttribute('aria-disabled', ready ? 'false' : 'true');

    if (textEl) {
      if (!size) {
        textEl.textContent = 'Select a Size';
      } else if (filled < required) {
        textEl.textContent = 'Select Your Colors (' + filled + '/' + required + ')';
      } else {
        // var total = 0;
        // for (var i = 1; i <= required; i++) {
        //   var slot = wrapper.querySelector('[data-bundle-slot="' + i + '"]');
        //   var sel = slot && slot.querySelector('[data-bundle-color-swatch][aria-pressed="true"]');
        //   if (sel) {
        //     var handle = sel.getAttribute('data-handle');
        //     var prod = stockMap[handle];
        //     if (prod && prod.sizes && prod.sizes[size]) {
        //       total += prod.sizes[size].price;
        //     }
        //   }
        // }
        // var tiers = getTiers();
        // var discountPct = tiers[String(required)] || 0;
        // var salePrice = Math.round(total * (100 - discountPct) / 100);
        // if (discountPct > 0 && total > salePrice) {
        //   textEl.innerHTML = 'Add Bundle to Cart • ' + formatMoney(salePrice) + ' <span class="bundle-atc-compare">' + formatMoney(total) + '</span>';
        // } else {
        //   textEl.textContent = 'Add Bundle to Cart • ' + formatMoney(total);
        // }
        textEl.textContent = 'Add Bundle to Cart';
      }
    }
  }

  function init(wrapper) {
    if (!wrapper || wrapper.hasAttribute(INIT_ATTR)) return;
    wrapper.setAttribute(INIT_ATTR, 'true');

    const stockMap = getStockMap();

    // Swatch clicks
    wrapper.addEventListener('click', e => {
      const btn = e.target.closest('[data-bundle-color-swatch]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      const slotEl = btn.closest('[data-bundle-slot]');
      if (slotEl) {
        selectSwatch(slotEl, btn);
        updateGallery(wrapper, stockMap);
        updateATCButton(wrapper, stockMap);
      }
    });

    // Option changes (size or pack size)
    document.addEventListener('change', e => {
      if (!e.target.matches || !e.target.matches('input[name$="-Size"], input[name$="-Pack Size"], input[name$="Pack+Size"]')) return;

      if (e.target.name && e.target.name.indexOf('Pack') !== -1) {
        updatePackSize(wrapper);
      }

      updateAvailability(wrapper, stockMap);
      updateGallery(wrapper, stockMap);
      updateATCButton(wrapper);
    });

    document.addEventListener('variant:change', () => {
      updateAvailability(wrapper, stockMap);
      updateGallery(wrapper, stockMap);
      updateATCButton(wrapper);
    });

    // Initial state — no auto-selecting, gallery shows shell images
    updateAvailability(wrapper, stockMap);
    updateGallery(wrapper, stockMap);
    updateATCButton(wrapper);
  }

  function boot() {
    document.querySelectorAll('[data-bundle-color-pickers]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', e => {
    if (e && e.target) e.target.querySelectorAll('[data-bundle-color-pickers]').forEach(init);
  });
})();
